import { render, staticRenderFns } from "./returnD2D.vue?vue&type=template&id=53a7275e&scoped=true"
import script from "./returnD2D.vue?vue&type=script&lang=js"
export * from "./returnD2D.vue?vue&type=script&lang=js"
import style0 from "./returnD2D.vue?vue&type=style&index=0&id=53a7275e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a7275e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53a7275e')) {
      api.createRecord('53a7275e', component.options)
    } else {
      api.reload('53a7275e', component.options)
    }
    module.hot.accept("./returnD2D.vue?vue&type=template&id=53a7275e&scoped=true", function () {
      api.rerender('53a7275e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderCenter/returnNoteRecord/component/returnD2D.vue"
export default component.exports